// Not found and forbidden, inside the shell so navigation stays in reach.
// `home` is where the way back leads: the chat for the user app, Akun in the
// admin console.
import type { Role } from "../api";
import { ROLE_LABEL } from "../lib/labels";
import { Notice, PageHeader, useTitle } from "../ui/components";

interface Home {
  href: string;
  label: string;
}

const CHAT: Home = { href: "/", label: "Kembali ke Chat" };

export function NotFoundScreen({ home = CHAT }: { home?: Home }) {
  useTitle("Halaman tidak ditemukan");
  return (
    <>
      <PageHeader title="Halaman tidak ditemukan" lead="Alamat ini tidak ada di Public Procurement Tools (Pluto)." />
      <Notice
        tone="info"
        title="Periksa kembali alamatnya"
        action={
          <a className="btn btn-secondary" href={home.href}>
            {home.label}
          </a>
        }
      >
        <p>Tautan mungkin salah ketik atau halaman sudah dipindahkan.</p>
      </Notice>
    </>
  );
}

export function ForbiddenScreen({ role, home = CHAT }: { role: Role; home?: Home }) {
  useTitle("Akses ditolak");
  return (
    <>
      <PageHeader title="Akses ditolak" lead={`Peran ${ROLE_LABEL[role]} tidak dapat membuka halaman ini.`} />
      <Notice
        tone="warning"
        title="Halaman ini untuk peran lain"
        action={
          <a className="btn btn-secondary" href={home.href}>
            {home.label}
          </a>
        }
      >
        <p>Bila Anda memerlukan akses, hubungi Administrator satuan kerja Anda.</p>
      </Notice>
    </>
  );
}

/** A route whose role feature the Administrator switched off (GET /access/features). */
export function FeatureOffScreen({ role, name, home = CHAT }: { role: Role; name: string; home?: Home }) {
  useTitle("Fitur tidak tersedia");
  return (
    <>
      <PageHeader title="Fitur tidak tersedia" lead={`${name} sedang tidak dibuka untuk peran ${ROLE_LABEL[role]}.`} />
      <Notice
        tone="warning"
        title={`${name} dinonaktifkan untuk peran Anda`}
        action={
          <a className="btn btn-secondary" href={home.href}>
            {home.label}
          </a>
        }
      >
        <p>Administrator mengatur fitur yang terlihat untuk setiap peran. Hubungi Administrator bila Anda memerlukan akses.</p>
      </Notice>
    </>
  );
}

/** A paid feature on an account still waiting for activation. */
export function InactiveFeatureScreen({ name, home = CHAT }: { name: string; home?: Home }) {
  useTitle("Menunggu aktivasi");
  return (
    <>
      <PageHeader title="Menunggu aktivasi" lead={`${name} terbuka setelah akun Anda diaktifkan.`} />
      <Notice
        tone="info"
        title="Akun Anda menunggu aktivasi"
        action={
          <a className="btn btn-secondary" href={home.href}>
            {home.label}
          </a>
        }
      >
        <p>Hubungi admin setelah pembayaran. Sementara itu chat tetap dapat dipakai.</p>
      </Notice>
    </>
  );
}
